// LG U+ categories are stored as lgu_<kind> (load_lgu_products); Apple's as lowercase codes.
const CATEGORY_LABELS = {
  lgu_plan: 'U+ 요금제', lgu_addon: 'U+ 부가서비스', lgu_bundle: 'U+ 결합 할인',
  lgu_card: 'U+ 제휴카드', lgu_discount: 'U+ 요금 할인', lgu_internet: 'U+ 인터넷',
  lgu_iptv: 'U+tv', lgu_smarthome: 'U+ 스마트홈', lgu_smarthome_device: 'U+ 스마트홈 기기',
  lgu_tradein: 'U+ 중고폰 보상', lgu_guide: 'U+ 판매 가이드',
  mac: 'Mac', ipad: 'iPad', iphone: 'iPhone', watch: 'Apple Watch', airpods: 'AirPods',
  'apple-tv': 'Apple TV', vision: 'Apple Vision Pro', service: 'Apple 서비스',
};

export const categoryLabel = cat => CATEGORY_LABELS[cat] || cat;
